import * as React from "react";
import {
  ImageField,
  Create,
  TextInput,
  ImageInput,
  BooleanInput,
  NumberInput,
} from "react-admin";

import { SimpleForm } from "../common/SimpleForm";
import { IMAGE_MAX_SIZE } from "../constants/FileConstants";
import {
  validateMealTimes,
  validateOrder,
  validateRequired,
} from "../utils/Validations";
import LimitedArrayInput from "./components/LimitedArrayInput";

const PlaceTypeCreate = () => (
  <Create
    title="Crear Tipo de Lugar"
    mutationMode="pessimistic"
    redirect="list"
  >
    <SimpleForm>
      <TextInput source="name" label="Nombre" validate={validateRequired} />
      <ImageInput
        source="image"
        label="Imagen"
        accept={{
          "image/*": [],
        }}
        validate={validateRequired}
        maxSize={IMAGE_MAX_SIZE}
      >
        <ImageField source="src" title="Imagen" />
      </ImageInput>
      <LimitedArrayInput
        source="mealTimes"
        label="Momentos ideales (ordenados por prioridad)"
        validate={validateMealTimes}
      />
      <NumberInput
        source="order"
        label="Orden"
        min={1}
        validate={validateOrder}
        onWheel={(e) => e.target.blur()}
      />
      <TextInput
        source="iconName"
        label="Nombre de Ícono"
        validate={validateRequired}
      />
      <BooleanInput source="visible" label="Visible" defaultValue={true} />
      <BooleanInput source="active" label="Activo" defaultValue={true} />
    </SimpleForm>
  </Create>
);

export default PlaceTypeCreate;
